// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"ac220dd0","661":"40002b76"}[chunkId] + ".chunk.css";
};